module.exports = __webpack_public_path__ + "static/img/Frame 18222.6fded5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 18222.png
// module id = 66Nx
// module chunks = 12